import styled from 'styled-components';

export const ToggleWrapper = styled.div<{ disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  align-items: center;
`;

export const ToggleTrack = styled.div<{ isOn: boolean }>`
  width: 48px;
  height: 24px;
  border-radius: 9999px;
  background-color: ${({ isOn }) => (isOn ? 'green' : '#e5e5e5')};
  transition: background-color 0.2s ease;
  padding: 2px;
  display: flex;
  align-items: center;
`;

export const ToggleThumb = styled.div<{ isOn: boolean }>`
  height: 24px;
  width: 24px;
  background: white;
  border-radius: 100%;
  transition: transform 0.2s ease;
  transform: ${({ isOn }) => (isOn ? 'translateX(23px)' : 'translateX(2)')};
`;
